<template>
  <div class="container">
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">证书类型：</div>
        <div class="subject">
          <span
            v-for="(item, index) in ResourceCategories"
            :key="index"
            :class="{heightlight : Resourceindex==index}"
            @click="ResourceArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div
        class="cate_police"
        style="border-top: 1px solid #dcdfe6;margin-left: 86px;padding-top: 24px;display: flex;align-items: center;"
      >
        <!-- <div class="cate-all" ></div> -->
        <div class="subject" style="padding-right: 30px;">
          <!-- <span
            v-for="(item, index) in newList"
            :key="index"
            :class="{heightlight : newIndex==index}"
            @click="policeNew(index,item)"
          >{{item.name}}</span>-->
        </div>
        <el-input
          @keyup.enter.native="getCerInfoLoad"
          size="large"
          placeholder="请输入搜索内容"
          v-model="listQuerya.Name"
          class="input-with-select"
          style="width:287px;height:40px;font-size: 16px;border-radius:4px;flex-shrink: 0;"
        >
          <el-button
            slot="append"
            @click="getCerInfoLoad"
            icon="el-icon-search"
            style="background: #545c63;border-radius: 0px;height: 100%;color:white;font-size:16px;"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="content">
      <div class="content_left">
        <div class="zsxzLabelBox">
          <img src="@/assets/images/zsFile.png" alt="">
          <span>最新活动</span>
        </div>
        <div class="fgLine"></div>
        <div class="zsListBox">
          <div class="tablehead">
            <div style="width:130px;text-align:center;font-size:16px;margin-top:10px">
              <span>警种</span>
            </div>
            <div style="width:260px;text-align:center;font-size:16px;margin-top:10px">
              <span>活动单位</span>
            </div>
            <div style="width:300px;text-align:center;font-size:16px;margin-top:10px">
              <span>活动名称</span>
            </div>
            <div style="width:130px;text-align:center;font-size:16px;margin-top:10px">
              <span>证书数量</span>
            </div>
            <div style="width:170px;text-align:center;font-size:16px;margin-top:10px">
              <span>发证时间</span>
            </div>
          </div>
          <div class="table">
            <div v-if="tableList.length!==0">
              <div
                v-for="(item,index) in tableList"
                :key="index"
                class="table_container"
                @click="getcerid(item)"
                style="cursor: pointer;"
              >
                <div
                  style="width:130px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <span>{{item.jzDicName}}</span>
                </div>
                <div
                  style="width:260px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <span>{{item.actUnitZB}}</span>
                </div>
                <div
                  style="width:300px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <span v-html="item.name"></span>
                </div>
                <div
                  style="width:130px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <span>{{item.cnt}}</span>
                </div>
                <div
                  style="width:170px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
                >
                  <span>{{item.publishTime}}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <nodata></nodata>
            </div>
          </div>
          <div class="pageblock">
            <el-pagination
              v-if="dataCount>0"
              background
              prev-text="上一页"
              next-text="下一页"
              layout="total,prev, pager, next,jumper"
              :page-size="listQuerya.limit"
              :current-page.sync="listQuerya.page"
              :total="dataCount"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="content_right_bottom">
          <div class="title2">
            <span>证书月度发布排行榜</span>
          </div>
        </div>
        <div class="ranking">
          <div class="ranking_list" v-for="(item, index) in JzTongJiList" :key="index">
            <div :class="[{'oneLable':index === 0},{'twoLable':index === 1},{'threeLable':index === 2}]">{{ index + 1 }}</div>
            <div :title="item.name" class="textOverFlow" style="width:90px">{{ item.name }}</div>
            <div>共计 {{ item.cnt }} 份</div>
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <div class="yiceng">
        <div class="yiceng_title">
          <img src="@/assets/images/zsFile.png" alt/>
          <span>最新活动证书</span>
        </div>
        <!-- <div class="yiceng_more"><span style="color:#666666;font-size:16px">更多 ></span></div> -->
      </div>
      <div class="gitern"></div>
      <div class="info_container">
        <div class="tablehead">
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>证书编号</span>
          </div>
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>获奖人</span>
          </div>
          <div style="width:100px;text-align:center;font-size:18px;margin-top:10px">
            <span>警钟</span>
          </div>
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>活动名称</span>
          </div>
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>单位名称</span>
          </div>
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>发证时间</span>
          </div>
          <div style="width:200px;text-align:center;font-size:18px;margin-top:10px">
            <span>操作</span>
          </div>
        </div>

        <div class="table2" id="review_box" @mouseover="rollStop()" @mouseout="rollStart(60)">
          <div id="comment1">
            <div v-for="(item,index) in NewCerData" :key="index" class="table_container">
              <div
                style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.code}}</span>
              </div>
              <div
                style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.uid}}</span>
              </div>
              <div
                style="width:100px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.jzName}}</span>
              </div>
              <div
                style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.name}}</span>
              </div>
              <div
                style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.actUnitZB}}</span>
              </div>
              <div
                style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              >
                <span>{{item.publishTime}}</span>
              </div>
              <div
                style="width:200px;text-align:center;font-size:16px;font-weight:400;margin-top:10px;cursor: pointer;"
                @click="gotocerperson(item)"
                class="xiangqing"
              >
                <span>查看详情</span>
              </div>
            </div>
          </div>
          <div id="comment2"></div>
        </div>
      </div>
    </div>

    <!-- 证书数据 -->
    <el-dialog
      :title="nametitle+'证书数据'"
      :visible.sync="dialogVisible"
      width="70%"
      v-el-drag-dialog
      class="dialog-mini"
    >
      <div>
        <div class="tablehead">
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>证书编号</span>
          </div>
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>获奖人</span>
          </div>
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>活动名称</span>
          </div>
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>单位名称</span>
          </div>
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>发证时间</span>
          </div>
          <div style="width:200px;text-align:center;font-size:16px;margin-top:10px">
            <span>操作</span>
          </div>
        </div>
        <div class="table1">
          <div v-for="(item,index) in tablecerlist" :key="index" class="table_container">
            <div
              style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              <span>{{item.code}}</span>
            </div>
            <div
              style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              <span>{{item.uid}}</span>
            </div>
            <div
              style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >{{item.name}}</div>
            <div
              style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              <span>{{item.actUnitZB}}</span>
            </div>
            <div
              style="width:200px;text-align:center;font-size:16px;color:#333333;font-weight:400;margin-top:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            >
              <span>{{item.publishTime}}</span>
            </div>
            <div
              style="width:200px;text-align:center;font-size:16px;font-weight:400;margin-top:10px;cursor: pointer;"
              @click="gotocerperson(item)"
              class="xiangqing"
            >
              <span>查看详情</span>
            </div>
          </div>
        </div>
        <div class="pageblock">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="total,prev, pager, next,jumper"
            :page-size="listQueryb.limit"
            :current-page.sync="listQueryb.page"
            :total="dataCount2"
            @current-change="handleCurrentChange2"
            @size-change="handleSizeChange2"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- <linecom></linecom> -->
  </div>
</template>

<script>
import { getInfo } from '@/utils/auth';
import { getCity } from '@/api/public.js';
import * as certificate from '@/api/certificate/index';
import vHeader from '../header/index';
import linecom from '@/components/linecom/index';
import elDragDialog from '@/directive/el-dragDialog';
export default {
  components: {
    vHeader,
    linecom,
  },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      ResourceCategories: [{ name: '全部', id: 0 }], //证书类别
      Resourceindex: 0, //高亮默认为全部
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [
        { subType: 0, name: '最新' },
        { subType: 1, name: '最热' },
      ],
      newIndex: 0,
      nametitle: '',
      dialogVisible: false,
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      timer: null,
      listQueryb: {
        page: 1,
        limit: 10,
        id: '',
        key: null,
      },
      listQuerya: {
        // 查询教师数据库条件
        Page: 1,
        Limit: 10,
        State: 1,
        key: null,
        JzDicId: null, //警种
        Name: null,
        BeginTime: null,
        EndTime: null,
        typeid: null,
      },
      JzTongJiList: [],
      pageIndex: 1,
      tableList: [],
      pageSize: 13,
      dataCount: 0,
      dataCount2: 0,
      Status: false,
      tablecerlist: [],
      getceriditem: '',
      NewCerData: '',
    };
  },
  methods: {
    ResourceArea(index, item) {
      this.Resourceindex = index;
      this.listQuerya.typeid = item.id;
      // console.log(item);
      this.getCerInfoLoad();
    },
    //查询新热
    policeNew(index, item) {
      this.newIndex = index;
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
      });
    },
    // 点击证书获取单个证书里的所有数据
    getcerid(item) {
      if (getInfo('tokens')) {
        this.dialogVisible = true;
        this.nametitle = item.name;
        let para = this.listQueryb;
        para.id = item.id;
        // 将item存起来，后面分页调用
        this.getceridID = item;
        certificate.SearchCerDataList(para).then((res) => {
          // console.log(res);
          this.tablecerlist = res.data;
          this.dataCount2 = res.count;
        });
      } else {
        window.clikLogin();
      }
    },
    //跳转页面到单个个人证书页面
    gotocerperson(item) {
      if (getInfo('tokens')) {
        this.$router.push({
          path: '/certificate/peoplecerticate',
          query: {
            code: item.code,
          },
        });
      } else {
        window.clikLogin();
      }
    },
    // 加载所有证书列表
    getCerInfoLoad() {
      let para = this.listQuerya;
      certificate.getLoadQT(para).then((res) => {
        // this.tableList=res.data
        this.dataCount = res.count;
        this.changeColor(res.data);
        // console.log(this.tableList)
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuerya.Name && this.listQuerya.Name.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuerya.Name, 'gi');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;">' +
            this.listQuerya.Name +
            '</span>';
          resultsList[index].name = item.name.replace(
            replaceReg,
            replaceString
          );
        }
      });
      // this.results = []
      // this.results = resultsList
      this.tableList = [];
      this.tableList = resultsList;
      // console.log(this.tableList);
    },
    // 分页组件的页数跳转方法，证书列表
    handleSizeChange(val) {
      this.listQuerya.Limit = val;
      this.getCerInfoLoad();
    },
    handleCurrentChange(val) {
      this.listQuerya.Page = val;
      this.getCerInfoLoad();
    },
    // 证书详情分页数据
    handleSizeChange2(val) {
      this.listQueryb.limit = val;
      this.getcerid(this.getceriditem);
    },
    handleCurrentChange2(val) {
      this.listQueryb.page = val;
      this.getcerid(this.getceriditem);
    },
    // 证书警钟统计
    getCerInfoJzTongJi() {
      let para = {
        top: 10,
      };
      certificate.CerInfoJzTongJiTop(para).then((res) => {
        //  debugger
        this.JzTongJiList = res.result;
        //  console.log(this.JzTongJiList)
      });
    },
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      certificate
        .getPmiDic(this.listQuery)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
        })
        .catch(() => {});
    },
    policeClassArea(index, item) {
      this.policeClassindex = index;
      // debugger
      if (item.id == 0) {
        this.listQuerya.JzDicId = null;
      } else {
        this.listQuerya.JzDicId = item.id;
      }
      this.getCerInfoLoad();
      // this.questionMap()
      // this.timer = new Date().getTime()
    },
    roll(t) {
      var ul1 = document.getElementById('comment1');
      var ul2 = document.getElementById('comment2');
      var ulbox = document.getElementById('review_box');
      ul2.innerHTML = ul1.innerHTML;
      // console.log(ul2.innerHTML);
      ulbox.scrollTop = 0;
      this.rollStart(t);
    },
    rollStart(t) {
      var ul1 = document.getElementById('comment1');
      var ul2 = document.getElementById('comment2');
      var ulbox = document.getElementById('review_box');
      this.rollStop();
      this.timer = setInterval(() => {
        // 当滚动高度大于列表内容高度时恢复为0
        // scrollto是滚动高度
        // scrollHeight是盒子高度
        // 滚动高度加视图高度400为盒子高度
        if (ulbox.scrollTop + 400 >= ul1.scrollHeight) {
          ulbox.scrollTop = 0;
        } else {
          ulbox.scrollTop++;
        }
      }, t);
    },
    rollStop() {
      clearInterval(this.timer);
    },
    // 获取最新活动证书
    getCerInfoNewCerInfo() {
      let para = {
        top: 15,
      };
      certificate.CerInfoNewCerInfoTop(para).then((res) => {
        this.NewCerData = res.result;
      });
    },
  },
  mounted() {
    this.roll(60);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  created() {
    this.getDishi();
    // this.getPmiDictionary(1, this.policeClassification);
    this.getPmiDictionary(57, this.ResourceCategories);
    this.getCerInfoLoad();
    this.getCerInfoJzTongJi();
    this.getCerInfoNewCerInfo();
  },
};
</script>

<style lang="scss" scoped>
.container{
  padding-bottom: 44px;
}
.table {
  min-height: 400px;
}

.xiangqing:hover {
  color: #83aefa;
}
.tablehead {
  display: flex;
  height: 46px;
  color: #999999;
  background: #fff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}
.table_container {
  display: flex;
  height: 40px;
  border-bottom: 1px solid #efefef;
}
.nav {
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 10px;
}
.nav > div {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 5px;
}
.navpolice {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 10px;
  display: flex;
}
.navpolice > div:nth-child(1) {
  flex: 1;
}
.navpolice > div:nth-child(2) {
  flex: 11;
}
.navpolice > div {
  margin-bottom: 7px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.navpolice > div > div {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  margin-top: 10px;
  background: #ececec;
  opacity: 1;
  border-radius: 6px;
  padding-left: 10px;
  padding-right: 10px;
}
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}
.table_container2 {
  transform: translateY(-55px);
  transition: 3s;
}

.content {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 14px;
  width: 1200px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  padding: 22px 14px 0px 14px;
  border-radius: 4px;
}
.content_left {
  width: 846px;
  min-height: 500px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);

  .zsxzLabelBox{
    box-sizing: border-box;
    padding: 18px 0px 7px 37px;
    display: flex;
    align-items: center;
    &>img{
      width: 30px;
      height: 33px;
      margin-right: 23px;
    }
    &>span{
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #000;
    }
  }

  .fgLine{
    height: 2px;
    width: 100%;
    background: linear-gradient(to right, #4192FF, #DB4144);
  }

  .zsListBox{
    box-sizing: border-box;
    padding: 0px 35px;
  }


}
.content_right {
  width: 303px;
  height: 580px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 19px 15px 0px 15px;
}
.title {
  font-size: 22px;
  margin-left: 6px;
  margin-top: -2px;
  font-weight: bold;
}
.content_right_bottom {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.title2 {
  font-size: 16px;
  color: #4D515A;
  font-weight: bold;
  line-height: 24px;
}
.more2 {
  font-size: 18px;
  margin-left: 40px;
  font-weight: 500;
  color: #285fbe;
  font-weight: bold;
}

.ranking_list {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  &>div:nth-child(1){
    flex-shrink: 0;
    min-width: 18px;
    height: 18px;
    background-color: transparent;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #768297;
    border-radius: 3px;
    margin-right: 7px;
  }

  .oneLable{
    background-color: #FFE8E3 !important;
    color: #FF7070 !important;
  }
  .twoLable{
    background-color: #FFEDD2 !important;
    color: #FF9255 !important;
  }
  .threeLable{
    background-color: #FFF4CC !important;
    color: #F4AD00 !important;
  }
  &>div:nth-child(2){
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #31303F;
  }
  &>div:nth-child(3){
    flex-shrink: 0;
    margin-left: 10px;
    font-size: 400;
    font-size: 12px;
    line-height: 18px;
    color: #7D899D;
  }
}

.info {
  width: calc(1200px - 28px);
  margin: 0 auto;
  border-radius: 4px;
  margin-top: 18px;
  box-sizing: border-box;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
}
.yiceng {
  display: flex;
}
.yiceng_title {
  display: flex;
  box-sizing: border-box;
  padding: 18px 0px 7px 38px;
  &>img{
    width: 30px;
    height: 33px;
    margin-right: 23px;
  }
  &>span{
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000;
  }
}
.yiceng_more {
  margin-left: 950px;
  margin-top: 20px;
}
.info_container {
  margin-top: 20px;
  box-sizing: border-box;
  padding: 0px 30px 20px 30px;
}
.one {
  width: 250px;
  text-align: center;
  line-height: 300px;
}
.pageblock {
  margin: 16px 0px;
  text-align: center;
}
.table2 {
  height: 400px;
  overflow: hidden;
}

.cate {
  box-sizing: border-box;
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}
.cate_police {
  display: flex;
  font-size: 16px;
}
.cate_police + .cate_police{
  margin-top: 12px;
}

.cate-all {
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject{
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  opacity: 1;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 4px;
}

.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}

.textOverFlow{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style scoped>
/deep/ .el-dialog__header {
  padding: 20px;
}
/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}
</style>